module.exports = __webpack_public_path__ + "img/pr-15.8d36982a.png";